import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-service',
  templateUrl: './show-service.component.html',
  styleUrls: ['./show-service.component.scss'],
})
export class ShowServiceComponent implements OnInit {
  service = '';

  constructor(private db: DbService) {}

  async ngOnInit(): Promise<void> {
    const admin = await this.db.doc$('master/masterInfo').pipe(take(1)).toPromise();
    this.service = admin.termsInfo.service;
  }
}
